// PROMPT 150: mensajes automaticos de bienvenida y ausencia de una marca (dentro del dialogo del Canal).
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const LARGO_MAX = 1000;
const DIAS = ["lunes", "martes", "miércoles", "jueves", "viernes", "sábado", "domingo"];
const SUGERIDOS = {
  bienvenida: {
    texto_es: "¡Hola! Gracias por escribir a {marca}. En un momento te respondemos.",
    texto_en: "Hi! Thanks for contacting {marca}. We'll get back to you shortly.",
  },
  ausencia: {
    texto_es:
      "¡Hola! Gracias por escribir a {marca}. Ahora estamos fuera de horario: te respondemos apenas volvamos ({horario}).",
    texto_en:
      "Hi! Thanks for contacting {marca}. We're out of office right now and will reply as soon as we're back ({horario}).",
  },
};
const IDIOMAS = [
  ["texto_es", "Texto en español"],
  ["texto_en", "Texto en inglés"],
];

function horarioDe(b) {
  const dias = Array.isArray(b.wa_horario_dias) ? b.wa_horario_dias : [];
  const corrido = dias.length > 1 && dias.every((d, i) => d === dias[0] + i);
  let cuando = "";
  if (dias.length) cuando = corrido ? `${DIAS[dias[0]]} a ${DIAS[dias[dias.length - 1]]}` : dias.map((d) => DIAS[d]).join(", ");
  return `${cuando ? `${cuando} ` : ""}de ${b.wa_horario_desde || "09:00"} a ${b.wa_horario_hasta || "18:00"}, hora de Nueva York`;
}

function Mensaje({ slug, que, titulo, ayuda, ayudaTexto, valor, onChange, deshabilitado, extra }) {
  const cfg = valor || { activa: false, texto_es: "", texto_en: "" };
  const cambiar = (parte) => onChange({ ...cfg, ...parte });
  return (
    <div className="rounded-md border border-slate-200 bg-slate-50/60 p-2.5" data-testid={`wa-auto-${que}-${slug}`}>
      <label className="flex cursor-pointer items-start gap-2">
        <input
          type="checkbox"
          className="mt-0.5 h-4 w-4 accent-emerald-600"
          checked={Boolean(cfg.activa)}
          disabled={deshabilitado}
          onChange={(e) => cambiar({ activa: e.target.checked })}
          data-testid={`wa-auto-${que}-activa-${slug}`}
        />
        <span className="min-w-0">
          <span className="block text-sm font-medium text-slate-800">{titulo}</span>
          <span className="block text-[11px] text-slate-500">{ayuda}</span>
        </span>
      </label>
      {cfg.activa ? (
        <div className="mt-2 space-y-2">
          {extra}
          {IDIOMAS.map(([campo, rotulo]) => (
            <div key={campo}>
              <Label className="text-xs text-slate-600">
                {rotulo}{" "}
                <span className="text-slate-400">
                  ({(cfg[campo] || "").length}/{LARGO_MAX})
                </span>
              </Label>
              <Textarea
                value={cfg[campo] || ""}
                maxLength={LARGO_MAX}
                disabled={deshabilitado}
                onChange={(e) => cambiar({ [campo]: e.target.value })}
                className="mt-1 min-h-[64px] bg-white text-base lg:text-sm"
                data-testid={`wa-auto-${que}-${campo}-${slug}`}
              />
              {!deshabilitado ? (
                <button
                  type="button"
                  onClick={() => cambiar({ [campo]: SUGERIDOS[que][campo] })}
                  className="mt-0.5 text-[11px] text-emerald-700 underline hover:text-emerald-800"
                  data-testid={`wa-auto-${que}-sugerido-${campo}-${slug}`}
                >
                  Usar el texto sugerido
                </button>
              ) : null}
            </div>
          ))}
          <p className="text-[11px] text-slate-500">{ayudaTexto}</p>
        </div>
      ) : null}
    </div>
  );
}

export default function MensajesAutomaticos({ slug, b, set, editable }) {
  const coexistencia = Boolean(b.wa_coexistencia);
  const deshabilitado = !editable;
  return (
    <div className="space-y-2" data-testid={`wa-automaticos-${slug}`}>
      <div>
        <p className="text-sm font-medium text-slate-800">Mensajes automáticos</p>
        <p className="text-[11px] text-slate-500">
          Se mandan solo si el agente no contesta. La ausencia usa el horario de atención de esta marca.
        </p>
      </div>
      {coexistencia ? (
        <p className="rounded-md bg-slate-100 px-2.5 py-1.5 text-xs text-slate-600" data-testid={`wa-automaticos-celular-${slug}`}>
          Se configuran en la app del celular.
        </p>
      ) : (
        <>
          <Mensaje
            slug={slug}
            que="bienvenida"
            titulo="Bienvenida"
            ayuda="Sale con el primer mensaje del cliente, o si hace más de 14 días que no escribía."
            ayudaTexto="Podés usar {marca} para poner el nombre de la marca."
            valor={b.wa_bienvenida}
            onChange={(v) => set(slug, "wa_bienvenida", v)}
            deshabilitado={deshabilitado}
          />
          <Mensaje
            slug={slug}
            que="ausencia"
            titulo="Ausencia"
            ayuda="Sale fuera del horario de atención, una sola vez cada 12 horas."
            ayudaTexto="Podés usar {marca} y {horario}."
            valor={b.wa_ausencia}
            onChange={(v) => set(slug, "wa_ausencia", v)}
            deshabilitado={deshabilitado}
            extra={
              <p className="text-[11px] text-slate-600" data-testid={`wa-auto-horario-${slug}`}>
                Horario de atención: {horarioDe(b)}.
              </p>
            }
          />
          {deshabilitado ? <p className="text-[11px] text-slate-500">Solo un administrador puede cambiarlos.</p> : null}
        </>
      )}
    </div>
  );
}
